import request from '@/utils/request'

// 查询小微企业-律师团列表
export function listLstmd(query) {
  return request({
    url: '/web/xwqy/lawyers/list',
    method: 'get',
    params: query
  })
}